export class AppConfig {
  public production = true;
  public apiUrl;
  public adminurl;
  public wsUrl;
  public version;
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts